import React from 'react';
import styles from "./Content.module.css";
import {cn} from "../../../utils/cn.ts";

export const Vacancy: React.FC = () => {
  return (
      <div style={{width: '100%', maxWidth: 1270, display: 'flex', flexDirection: 'column', flexBasis: 'inherit',}}>
      <div className={cn(styles.container)}>
        <div  className={cn(styles.gridXs12, styles.item)}>
          <div className={cn(styles.typography,styles.mainTitle)}>Работа в ПОДЗАМЕНУ</div>
        </div>
        <div className={cn(styles.container,styles.subTitle)}>
          <div className={cn(styles.gridXs12, styles.item)} style={{marginBottom: 15,}}>
            Приветствуем в сервисе подбора автотоваров ПОДЗАМЕНУ!
          </div>
          <div className={cn(styles.gridXs12, styles.item)}>
            Мы настоящие эксперты в области автотоваров и задаём стандарты в продажах.
          </div>
          <div className={cn(styles.gridXs12, styles.item)}>
            Мы не просто продаём автотовары - мы делимся своей страстью к автомобилям.
          </div>
          <div  className={cn(styles.gridXs12, styles.item)} style={{marginBottom: 15,}}>
            Ради этого мы ходим на работу каждый день.
          </div>
          <div  className={cn(styles.gridXs12, styles.item)} style={{marginBottom: 15,}}>
            Приглашаем в команду энергичных и инициативных.
          </div>
          <div  className={cn(styles.gridXs12, styles.item)}>
            <a href={`https://vladivostok.hh.ru/search/vacancy?from=employerPage&employer_id=1104536`} target="_blank" className={styles.linkA}>Здесь можно посмотреть список вакансий на hh.ru</a>
          </div>
          <div  className={cn(styles.gridXs12, styles.item)} style={{marginBottom: 15,}}>
            <a href={`https://www.farpost.ru/user/HRshop/#center=43.136796883862196%2C131.93078937468448&zoom=16`} target="_blank" className={styles.linkA}>Здесь можно посмотреть список вакансий на farpost</a>
          </div>
        </div>
      </div>
      </div>
  );
};
